import * as React from "react";
import { ComponentType } from "./ComponentType.js";
import * as cls from "./Text.module.scss";
const cType = new ComponentType("Text", "text_", cls);
export { Text };
/**
 * Задаёт различные стили оформления текста.
 * @param {Object} props - Атрибуты элемента.
 * @param {Text.Type} [props.type=default] - Тип текста.
 * @param {string} [props.className] - Дополнительные классы CSS.
 * @param {JSX.Element} props.children - Текст.
 * @returns {JSX.Element} Элемент JSX.
 * @example
 * <Text type="primary">Содержимое</Text>
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Text(
  {
    type = "default",
    className,
    children
  }) {
  const fullClassName = cType.getFullClassName(type, className);
  let tagName = "span";
  const props = { className: fullClassName };
  if ("mute" == type) {
    props.role = "img";
  }
  return React.createElement(tagName, props, children);
}
/** 
 * Типы текста.
 * @enum {string}
 * @inner
 */
Text.Type =
{
  /** По умолчанию ничего не делает с текстом. */
  DEFAULT: "default",
  /** Жирный текст, выделенный основным цветом. */
  PRIMARY: "primary",
  /** Второстепенный текст, выделенный серым цветом. */
  SECONDARY: "secondary",
  /** Красный текст. Сообщение об ошибке. */
  DANGER: "danger",
  /** Текст, который нужно отображать на экране, но не произносить вслух. */
  MUTE: "mute",
  /** Текст, который нужно произносить вслух, но не отображать на экране. */
  VOX: "vox",
};
